import videojs, { VideoJsPlayer, VideoJsPlayerOptions } from "video.js"

;(window as any).VIDEOJS_NO_DYNAMIC_STYLE = true

export function createVideoPlayer(
  videoElement: HTMLVideoElement,
  customOption?: any,
): CunstomVideoJsPlayer {
  let defaultOption: VideoJsPlayerOptions = {
    autoplay: true,
    controls: true,
    preload: "auto",
    liveui: true,
  }

  const videojsPlayer: CunstomVideoJsPlayer = videojs(videoElement, {
    ...defaultOption,
    ...customOption,
  })

  return videojsPlayer as CunstomVideoJsPlayer
}

export interface CunstomVideoJsPlayer extends VideoJsPlayer {
  stop?: Function
  start?: Function
  setVolume?: Function
  setStreamURL?: Function
  setCallbacks?: Function
}
